import React, { useState, useEffect, useContext } from 'react';

import {
	Container,
	IconButton,
	Paper,
	TableContainer,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	Table,
	Typography,
	Stack,
	TextField,
	InputAdornment,
	Chip,
	Tooltip
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faTrashAlt, faExternalLink } from '@fortawesome/free-solid-svg-icons';
import { isEmpty } from 'lodash';
import { DataContext } from '../../../context/DataContext';
import { getToken } from '../../../api/Account';
import { getDeviceUnauthorizedAsync } from '../../../api/Users';
import { simpleMessage } from '../../../helpers/Helpers';
import NoData from '../../../components/NoData';
import moment from 'moment';

const IntentoLoginList = ({ userId }) => {
	const [intentoList, setIntentoList] = useState([]);
	// console.log('🚀 ~ intentoList:', intentoList);

	const { setIsLoading, setIsLogged, setIsUnautorized, access } = useContext(DataContext);

	const token = getToken();

	const getData = async () => {
		setIsLoading(true);
		let result = await getDeviceUnauthorizedAsync(token, userId);

		if (!result.statusResponse) {
			setIsLoading(false);
			if (result.error === 'Unauthorized') {
				setIsUnautorized(true);
				return;
			}
			simpleMessage(result.error, 'error');
			return;
		}

		// console.log(result.data ?? []);
		setIntentoList(result.data.result ?? []);
		setIsLoading(false);
	};

	useEffect(() => {
		getData();
	}, []);

	return (
		<div>
			<Container maxWidth="xl">
				{isEmpty(intentoList) ? (
					<NoData />
				) : (
					<Stack spacing={2}>
						<TableContainer>
							<Table aria-label="simple table" size="small">
								<TableHead>
									<TableRow>
										<TableCell align="center" className="text-primary fw-bold">
											#
										</TableCell>

										<TableCell align="center" className="text-primary fw-bold">
											Fecha Intento
										</TableCell>
										<TableCell align="center" className="text-primary fw-bold">
											S.O.
										</TableCell>

										<TableCell align="center" className="text-primary fw-bold">
											Plataforma
										</TableCell>
										<TableCell align="center" className="text-primary fw-bold">
											Id Dispositivo
										</TableCell>
										<TableCell align="center" className="text-primary fw-bold">
											Version
										</TableCell>
									</TableRow>
								</TableHead>

								<TableBody>
									{intentoList.map((row) => {
										const {
											deviceId,
											id,
											fecha,
											userBrowser,
											userSO,
											version
										} = row;

										return (
											<TableRow key={id}>
												<TableCell
													align="center"
													component="th"
													scope="row"
												>
													{id}
												</TableCell>

												<TableCell align="center">
													{moment(fecha).format('DD/MM/YYYY HH:mm:ss')}
												</TableCell>
												<TableCell align="center">{userSO}</TableCell>

												<TableCell align="center">{userBrowser}</TableCell>
												<TableCell align="center">{deviceId}</TableCell>
												<TableCell align="center">{version}</TableCell>
											</TableRow>
										);
									})}
								</TableBody>
							</Table>
						</TableContainer>
					</Stack>
				)}
			</Container>
		</div>
	);
};

export default IntentoLoginList;
